import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { jobAutoCompleteInput$, jobAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const JobAutoSuggest = renderAutoSuggestWithOptions(
   jobAutoCompleteObservable$,
   jobAutoCompleteInput$,
);

JobAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   filterOrganization: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search Job Title...',
};

export default JobAutoSuggest;
